import { fileExtensionForType, fileURLFromJSONValue, intFromJSONValue, stringFromJSONValue } from './parser'

export class AttachmentModel {
  public file: string
  public name: string
  public type: string
  public refresh: number
  public width: number
  public height: number

  public constructor(file: string, name: string, type: string, refresh: number, width: number, height: number) {
    this.file = file
    this.name = name
    this.type = type
    this.refresh = refresh
    this.width = width
    this.height = height
  }

  public static modelFromJSON(json: any): AttachmentModel {
    return new AttachmentModel(
      stringFromJSONValue(json['File']),
      stringFromJSONValue(json['Name']),
      stringFromJSONValue(json['Type']),
      intFromJSONValue(json['Refresh']),
      intFromJSONValue(json['Width']),
      intFromJSONValue(json['Height'])
    )
  }

  public url() {
    return fileURLFromJSONValue(this.file, fileExtensionForType(this.type))
  }
}
